import { DOCUMENT_REQUEST_CATEGORY } from 'common/constants/process-management';

export const INFORMATION_REQUEST_DEFAULT_EXPIRATION_DAYS = 14;

type ExpirationRequest = {
  category?: number;
  expiration_date?: string | null;
};

export const getDefaultInformationRequestExpirationDate = (): Date => {
  const date = new Date();
  date.setDate(date.getDate() + INFORMATION_REQUEST_DEFAULT_EXPIRATION_DAYS);
  return date;
};

export const isValidInformationRequestExpirationDate = (date: Date | null): date is Date =>
  date instanceof Date && !Number.isNaN(date.getTime());

export const parseInformationRequestExpirationDate = (iso: string): Date => {
  const parsed = new Date(iso);
  return isValidInformationRequestExpirationDate(parsed)
    ? parsed
    : getDefaultInformationRequestExpirationDate();
};

// Calendar dates expire at the end of the selected local day so HMAC `now > expiration`
// matches "this date is still valid".
export const toInformationRequestExpirationIso = (date: Date): string => {
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay.toISOString();
};

export const getInformationRequestExpirationFromRequests = (
  requests: ExpirationRequest[]
): string | undefined => {
  const documentRequest = requests.find(request => request.category === DOCUMENT_REQUEST_CATEGORY);
  return documentRequest?.expiration_date ?? requests.find(request => request.expiration_date)?.expiration_date ?? undefined;
};
